import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    width: '300px',
    margin: '10px',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  title: {
    fontSize: '15px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
  },
};

export const Button = styled.button`
  width: ${(props) => (props.width === 'fullWidth' ? '100%' : '200px')};
  transition: all 0.5s ease-in-out;
  background-color: #FFA500;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 36px;
  letter-spacing: 1px;
  margin:${(props) => (props.width === 'fullWidth' ? '0' : '10px 15px')};
  &:hover {
    background-color: #da8d00;
    border-color: #fff;
  }
  &:disabled {
    background-color: grey;
    border-color: #fff;
  }
}
`;

export const useStyles = makeStyles(styles);
